import React, { Component } from 'react';
import PropTypes from "prop-types";

import Graphics from './contents/Graphics/Graphics';

// Styles
import './PowerSupply.scss';

export class PowerSupply extends Component {

  componentWillMount() {
    this.props.createPowerSupply({
      props: this.props.defaultProps,
    });
  }

    showPowerSupplyModal = () => {
        this.props.setModal({
            type: 'POWERSUPPLY_CONTROLS',
            size: 'inside',
            connect: this.props.id
          });
        this.props.showModal({display: true});
    }


    render() {
        return (
            <ul>
                <li
                    id="PowerSupply"
                    tabIndex={0}
                    onClick={this.showPowerSupplyModal}
                    onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.showPowerSupplyModal(e)} }
                    >
                    <div className="connections">
                      <div className="electrodes">
                        <div className="group">
                          <div className="electrode">
                            <div id={'PowerSupply_1_NegativeElectrode'} className="dropTarget">
                              <p aria-hidden="true" className="label" style={{display:"none"}}>Power Supply Anode</p>
                            </div>
                          </div>
                        </div>
                        <div className="group">
                          <div className="electrode">
                            <div id={'PowerSupply_1_PositiveElectrode'} className="dropTarget">
                              <p aria-hidden="true" className="label" style={{display:"none"}}>Power Supply Cathode</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p aria-hidden="true" className="label">Power supply</p>
                    <Graphics/>
                </li>
            </ul>
        )
    }
}
PowerSupply.propTypes = {
  createPowerSupply: PropTypes.func,
};

PowerSupply.defaultProps = {
};


// const mapStateToProps = (state, ownProps) => {
//   if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("powerSupply")){
//  return {
//     anodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply.anodeConnected,
//     cathodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply.cathodeConnected,
//     active: state.notebook.protocolSection.scene.apparatus.powerSupply.active,
//     voltage: state.notebook.protocolSection.scene.apparatus.powerSupply.voltage,
//     current: state.notebook.protocolSection.scene.apparatus.powerSupply.current,
//  }
// } else {
//  return {}
// }
// };

// export default connect(mapStateToProps, {
//     setPowerSupplyAnodeConnected,
//     setPowerSupplyCathodeConnected,
//     setModal,
//     showModal,
//     createPowerSupply,
// })(PowerSupply);
